import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {TranslocoService} from '@jsverse/transloco';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import {GlobalService} from '../../../../../global/global.service';
import {IGetSavedListingFiltersResponseDTO} from '../../save-filters.dto';

@Component({
    selector: 'app-saved-filters',
    templateUrl: './saved-filters.component.html',
    styleUrl: './saved-filters.component.scss'
})
export class SavedFiltersComponent {
    private _filters: IEditableFilter<IGetSavedListingFiltersResponseDTO>[] = [];
    readonly minimalNameLength = 5;

    @Input() set filters(filters: IGetSavedListingFiltersResponseDTO[]) {
         this._filters = filters?.map(x => ({
            filter: {...x},
            isEditMode: false
        })) || [];
    }

    get filters(): IEditableFilter<IGetSavedListingFiltersResponseDTO>[] {
        return this._filters;
    }

    @Input() isLoading: boolean = false;

    @Output() deleteFilter: EventEmitter<IGetSavedListingFiltersResponseDTO> = new EventEmitter();
    @Output() editFilter: EventEmitter<IGetSavedListingFiltersResponseDTO> = new EventEmitter();

    editFilterForm = this._formBuilder.group({
        public: [false, Validators.required],
        name: ['', [Validators.required, Validators.minLength(this.minimalNameLength)]],
    });

    constructor(public modal: NgbActiveModal,
                private _formBuilder: FormBuilder,
                public globalService: GlobalService,
                private _translocoService: TranslocoService) {
    }

    async onDeleteFilter(filter: IEditableFilter<IGetSavedListingFiltersResponseDTO>): Promise<void> {
        const result = await this.confitmDeletion(filter.filter.name);
        if (result.value) {
            this.deleteFilter.emit(filter.filter);
        }
    }

    onEditFilter(filter: IEditableFilter<IGetSavedListingFiltersResponseDTO>): void {
        filter.isEditMode = true;

        this._filters.forEach( (x)=>{
            if(x.filter.id!= filter.filter.id){
               x.isEditMode = false;
           }
        });

        this.editFilterForm.patchValue({
            public: filter.filter.public,
            name: filter.filter.name
        });

    }

    updateFilter(filterToUpdate: IEditableFilter<IGetSavedListingFiltersResponseDTO>) {
        if(this.editFilterForm.valid){
            this.editFilter.next(
                {
                    ...filterToUpdate.filter,
                    name: this.editFilterForm?.value?.name || filterToUpdate.filter.name,
                    public: this.editFilterForm?.value?.public  !=null ? this.editFilterForm?.value?.public : filterToUpdate.filter.public,
                }
            );
        }
    }

    private async confitmDeletion(filterName: string) {
        return await Swal.fire({
            title: this._translocoService.translate('Saved filters (documents and contract card) - confirm deletion title') ,
            text: this._translocoService.translate('Saved filters (documents and contract card) - confirm deletion title', {filterName:filterName}),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: this._translocoService.translate('Modal button (general) - Yes'),
            confirmButtonColor: '#ef0016',
            cancelButtonText: this._translocoService.translate('Modal button (general) - Yes'),
        });
    }
}

export interface IEditableFilter<T> {
    isEditMode: boolean
    filter:T
}

export interface ISaveNewFilter {
    public: boolean,
    name: string
}
